module.exports = __webpack_public_path__ + "c4dca95a7fae9aa30ad37611891ead61.png";